import type React from 'react'
import { useState } from 'react'
import styled from 'styled-components'

import Button from '@/components/Button'
import DangerButton from '@/components/DangerButton'
import { graphQLQuery } from '@/hooks/hooks'
import type { Application } from '@/types/Activity'
import { Colours } from '@/utils/styles'

import TextInput from './DEPRECATED_UI/TextInput'

interface Props {
  application: Application
  onCancelSuccess: Function
  personId?: string
}

const Container = styled.div`
  padding: 5px;
  border-radius: 0 0 5px 5px;
  position: relative;
  z-index: 10;
  background: #fff;
  width: 100%;
  &:hover {
    cursor: pointer;
  }
`

const ConfirmContainer = styled.div`
  h5 {
    color: ${Colours.lightGray};
  }

  span {
    color: ${Colours.red};
    user-select: unset;
  }
`

const ToggleArea = styled.div`
  display: flex;
  justify-content: space-between;
  img {
    transform: rotate(270deg);
  }
`

const ButtonGroup = styled.div`
  display: flex;
  button {
    width: 100%;
  }
`

const ReinstateButton = styled(Button)`
  width: 90%;
`

const DangerZone: React.FC<Props> = ({ application, onCancelSuccess, personId }) => {
  const [dangerOpen, setDangerOpen] = useState(false)
  const [confirming, setConfirming] = useState(false)
  const [username, setUsername] = useState('')

  function handleCancelOrReinstateApp(TYPE: 'CANCEL' | 'REINSTATE') {
    graphQLQuery({
      query: `mutation($cusId: String! , $appId: String!, $subId: String!, $personId: String!, $logicAppRunId: String){
        updateDecision(TYPE: ${TYPE}, cusId: $cusId, appId: $appId, subId: $subId, personId: $personId, logicAppRunId: $logicAppRunId)
      }`,
      variables: {
        cusId: application.customerId,
        appId: application.applicationId,
        subId: application.subjectId,
        personId: personId,
      },
    })
      .then(resData => {
        return resData.json()
      })
      .then(data => {
        onCancelSuccess()
      })
  }

  if (!application || !application.name) return null

  return (
    <Container data-tip="hello world">
      <ToggleArea onClick={() => setDangerOpen(!dangerOpen)}>
        <h2>Danger Zone</h2>

        <img
          src="/assets/svg/collapse.svg"
          style={{ transform: `${dangerOpen ? 'rotate(90deg)' : ''}` }}
          alt=""
        />
      </ToggleArea>
      {/* 
        REINTSATE APPLICATION
      */}
      {dangerOpen &&
        !confirming &&
        application.outcome &&
        application.outcome.status === 'Cancelled' && (
          <ReinstateButton onClick={() => setConfirming(true)}>
            Reinstate Application
          </ReinstateButton>
        )}
      {/* 
        CONFIRM REINSTATING
      */}
      {confirming &&
        application.outcome &&
        application.outcome.status === 'Cancelled' && (
          <ConfirmContainer>
            <h5>
              Are you sure you would like to reinstate the application of{' '}
              {application.name}?
            </h5>
            <ButtonGroup>
              <Button onClick={() => handleCancelOrReinstateApp('REINSTATE')}>
                Reinstate
              </Button>
              <Button onClick={() => setConfirming(false)} $alternate>
                Cancel
              </Button>
            </ButtonGroup>
          </ConfirmContainer>
        )}
      {/* 
        CANCEL APPLICATION
      */}
      {dangerOpen &&
        !confirming &&
        application.outcome &&
        application.outcome.status !== 'Cancelled' && (
          <div className="side-by-side-flex">
            <DangerButton onClick={() => setConfirming(true)}>
              Cancel Application
            </DangerButton>
          </div>
        )}
      {/* 
          CONFIRM CANCEL APPLICATION
        */}
      {confirming &&
        application.outcome &&
        application.outcome.status !== 'Cancelled' && (
          <ConfirmContainer>
            <h5>
              {' '}
              To confirm deletion of this application, please type{' '}
              <span>{application.name}</span> click delete.
            </h5>

            <TextInput
              value={username}
              onChange={(e: any) => setUsername(e.target.value)}
            />
            <ButtonGroup>
              <DangerButton
                onClick={() => handleCancelOrReinstateApp('CANCEL')}
                disabled={
                  username.split(' ').join().toLowerCase() !==
                  application.name.split(' ').join().toLowerCase()
                }
              >
                Delete
              </DangerButton>
              <Button onClick={() => setConfirming(false)} $alternate>
                Cancel
              </Button>
            </ButtonGroup>
          </ConfirmContainer>
        )}
    </Container>
  )
}

export default DangerZone
